module.exports = __webpack_public_path__ + "img/r1.dc6f014b.png";